module.exports = __webpack_public_path__ + "static/media/BCR Banner Without Logo.18baca9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BCR Banner Without Logo.png
// module id = 459
// module chunks = 0